// Exact public-storefront variants checked 2026-10-12. Sunshades excluded.
window.TES_BUNDLES = [
  {
    "key": "tes-bundle-0",
    "model": "Model Y Juniper",
    "name": "Juniper All-Weather Weekend Kit",
    "description": "All-weather floor protection, convenient frunk access and weekend essentials.",
    "fit": "Model Y Juniper Premium · 2025.03+ · 5-seat · Excludes Berlin · Left-hand drive",
    "items": [
      {
        "name": "Hidden Trunk Fridge",
        "handle": "tesstudio-hidden-trunk-fridge-tesla-model-y-juniper",
        "variant": "51261817782561",
        "spec": "Model Y Juniper 5-Seat (03/2025+) – Excl. Berlin",
        "priceCents": 46700,
        "image": window.TES_HW.assets["assets/bundles/bundle-0-0.jpg"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Trunk_Fridge_Hidden_Cooler_Car_Mini_Refrigerator_for_Tesla_Model_Y_Model_Y_Juniper_-_Tesstudio.jpg?v=1779421937"
      },
      {
        "name": "All-Weather Floor & Cargo Mat Set",
        "handle": "model-y-juniper-2025-all-weather-tpe-floor-mats-pet-mats-bundle",
        "variant": "53025028014369",
        "spec": "Model Y Juniper · 2025+ · Left-hand drive · Floor mats and pet cargo liner",
        "priceCents": 24000,
        "image": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_TPE_Mats_Floor_Mats_For_Tesla_Model_Y_Juniper.jpg?v=1763449431",
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_TPE_Mats_Floor_Mats_For_Tesla_Model_Y_Juniper.jpg?v=1763449431"
      },
      {
        "name": "Power Frunk Lift Kit",
        "handle": "power-frunk-silent-front-trunk-electric-suction-lock-v8",
        "variant": "51004223422753",
        "spec": "Model Y Juniper （03/2025+）",
        "priceCents": 40000,
        "image": window.TES_HW.assets["assets/bundles/bundle-0-2.jpg"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Model_Y_Juniper_03_2025_Power_Frunk_Automatic_opening_system_For_Tesla_-_Tesstudio.jpg?v=1780556387"
      },
      {
        "name": "Fog Light Trim Covers",
        "handle": "fog-light-trim-covers-abs-exterior-upgrade-for-tesla-model-y-juniper",
        "variant": "52846708261153",
        "spec": "Model Y Juniper Premium 2025.03+ / Matte Carbon Fiber Style",
        "priceCents": 8800,
        "image": window.TES_HW.assets["assets/bundles/bundle-0-3.webp"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Fog_Light_Trim_Covers_Matte_Carbon_Fiber_Style.webp?v=1781493468"
      }
    ],
    "notes": [
      "One of each selected item or retail set. Confirm the listed build date and options for every product.",
      "Five-seat Juniper Premium only. Fridge variant excludes Berlin-built cars. Fog-light trim is ABS with a matte carbon-fiber-style finish. Floor mats are the 3-piece cabin set for left-hand-drive Juniper only; not the 6-piece expanded set.",
      "Check installation clearances and requirements with the store before fitting multiple accessories. These are curated shopping suggestions, not a new combined SKU."
    ]
  },
  {
    "key": "tes-bundle-1",
    "model": "Model Y L",
    "name": "Model Y L Smart Cabin",
    "description": "Driver tech, discreet storage and a carbon-fiber finishing touch.",
    "fit": "Model Y L · 2026.06+ · Left-hand drive",
    "items": [
      {
        "name": "F96C Dashboard Display",
        "handle": "carplay-screen-dashboard-touchscreen-display-for-tesla-model-y-l",
        "variant": "53071871803681",
        "spec": "Model Y L (2026.03+) / With front camera - Left Hand Drive",
        "priceCents": 32400,
        "image": window.TES_HW.assets["assets/bundles/bundle-1-0.png"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/F96C.png?v=1784877037"
      },
      {
        "name": "Under-Screen Storage Tray",
        "handle": "tesla-model-y-l-magnetic-under-screen-storage-tray",
        "variant": "53184419463457",
        "spec": "Model Y L (2026.06+) / Black",
        "priceCents": 6200,
        "image": window.TES_HW.assets["assets/bundles/bundle-1-1.png"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/tesla-magnetic-under-screen-storage-tray-semi-transparent-black_345aa7a5-cf7b-41c2-b5a6-ada485f2ed72.png?v=1785811253"
      },
      {
        "name": "Carbon Fiber Armrest Cover",
        "handle": "real-carbon-fiber-center-console-armrest-cover-trim-for-tesla-model-y-l-2026-06",
        "variant": "53188382621985",
        "spec": "Model Y L (2026.06+) / Matte",
        "priceCents": 14900,
        "image": window.TES_HW.assets["assets/bundles/bundle-1-2.jpg"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/HM3MYJuniper_4.jpg?v=1744268351"
      },
      {
        "name": "Center Console Organizer",
        "handle": "center-console-organizer-tray-silicone-storage-box-for-model-y-l",
        "variant": "53184532414753",
        "spec": "Model Y L (2026.06+) / Center Console Organizers",
        "priceCents": 1900,
        "image": window.TES_HW.assets["assets/bundles/bundle-1-3.jpg"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/tesla-silicone-sunglasses-holder-storage-box-installed-view.jpg?v=1785812269"
      }
    ],
    "notes": [
      "One of each selected item or retail set. Confirm the listed build date and options for every product.",
      "Shared fit range: 2026.06+ left-hand-drive Model Y L. Dashboard display includes the selected front camera.",
      "Check installation clearances and requirements with the store before fitting multiple accessories. These are curated shopping suggestions, not a new combined SKU."
    ]
  },
  {
    "key": "tes-bundle-2",
    "model": "Model Y Standard",
    "name": "Model Y Standard Everyday Kit",
    "description": "Travel storage, a console upgrade and everyday protection.",
    "fit": "Model Y Standard · 2025.11+",
    "items": [
      {
        "name": "Tactical Window Storage Bags",
        "handle": "triangle-window-tactical-camping-storage-bag-pair-for-tesla",
        "variant": "53474978890017",
        "spec": "Model Y / Model Y Juniper / Model Y Standard",
        "priceCents": 22400,
        "image": window.TES_HW.assets["assets/bundles/bundle-2-0.png"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/ModelYJuniper_eb962455-873d-4f71-8622-4fbde4942d76.png?v=1788917250"
      },
      {
        "name": "Aroma Diffuser Dock",
        "handle": "aroma-diffuser-dock-for-tesla-model-3-model-3-highland-model-y-model-y-juniper-and-model-y-l",
        "variant": "53242325827873",
        "spec": "Model Y Standard (2025.11+)",
        "priceCents": 12400,
        "image": window.TES_HW.assets["assets/bundles/bundle-2-1.jpg"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/tesla-aroma-diffuser-dock-center-console-fit.jpg?v=1786435676"
      },
      {
        "name": "Carbon Fiber Handle Covers",
        "handle": "carbon-fiber-door-handle-covers-for-tesla-model-3-model-3-standard-model-y-model-y-juniper-model-y-standard-model-y-l",
        "variant": "53489976148257",
        "spec": "Model Y Standard (2025.11+) / Gloss",
        "priceCents": 7400,
        "image": window.TES_HW.assets["assets/bundles/bundle-2-2.png"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/6_5a0ca646-3bcd-4992-a66c-c2c3a8b0aec2.png?v=1789107116"
      },
      {
        "name": "Rear Seatback Protector Set",
        "handle": "model-y-standard-backrest-mat-cargo-liner",
        "variant": "52882131386657",
        "spec": "Model Y Standard · Rear seatback protector · 3-piece set",
        "priceCents": 9900,
        "image": window.TES_HW.assets["assets/bundles/bundle-2-3.jpg"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/61mbTbtSCvL._AC_SL1500.jpg?v=1782184397"
      }
    ],
    "notes": [
      "One of each selected item or retail set. Confirm the listed build date and options for every product.",
      "Use window storage bags only for lightweight items; keep visibility and airbags clear. Fragrance pads are not included with the diffuser dock unless listed by the store.",
      "Check installation clearances and requirements with the store before fitting multiple accessories. These are curated shopping suggestions, not a new combined SKU."
    ]
  },
  {
    "key": "tes-bundle-3",
    "model": "Model Y",
    "name": "Model Y Comfort & Convenience",
    "description": "Back-seat entertainment, personal comfort and convenient access.",
    "fit": "Model Y · 2020–2024 · Pre-Juniper",
    "items": [
      {
        "name": "R89 Plus Rear Display",
        "handle": "model-3-y-r89-rear-display-with-disney-plus-entertainment-february-2019",
        "variant": "52401257185569",
        "spec": "R89 Plus Rear Display / Model Y (2019-2025.02)",
        "priceCents": 34600,
        "image": window.TES_HW.assets["assets/bundles/bundle-3-0.jpg"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/tesla-model-3-y-rear-entertainment-screen-dual-controller-gaming.jpg?v=1786066109"
      },
      {
        "name": "Adjustable Neck Pillow",
        "handle": "spa-neck-pillow-adjustable-headrest-tesla-model-3-y",
        "variant": "51047404601633",
        "spec": "1pc / Black / Model Y （2019-2024）",
        "priceCents": 8200,
        "image": window.TES_HW.assets["assets/bundles/bundle-3-1.png"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/TeslaModel3YModel3HighlandCybertruckNeckPillowAdjustableSkin-friendlyHeadrestNeckPillow_2_e47bb44b-db8c-4126-bd69-bd6aa7b533cc.png?v=1734940003"
      },
      {
        "name": "Hands-Free Trunk Sensor",
        "handle": "laser-projection-hands-free-trunk-opener-system-kick-to-open",
        "variant": "52480287867169",
        "spec": "Model Y（2019-2025.02）",
        "priceCents": 12400,
        "image": window.TES_HW.assets["assets/bundles/bundle-3-2.png"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Kick-to-Open_Rear_Trunk_Sensor_System_for_Tesla_Model_Y_Y_Juniper.png?v=1776156888"
      },
      {
        "name": "App-Controlled Door LED Lights",
        "handle": "door-led-strip-lights-with-app-control-for-tesla-model-3-y-interior-ambient-lighting",
        "variant": "52620868518177",
        "spec": "Model Y (2020+)",
        "priceCents": 11500,
        "image": window.TES_HW.assets["assets/bundles/bundle-3-3.png"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Door_LED_Strip_Lights_with_APP_Control_for_Tesla_Model_3_3_Highland_Model_Y_Y_Juniper_Interior_Ambient_Lighting.png?v=1778059776"
      }
    ],
    "notes": [
      "One of each selected item or retail set. Confirm the listed build date and options for every product.",
      "Shared fit range: pre-Juniper Model Y 2020–2024. Neck pillow is one black pillow; R89 is the display-only option.",
      "Check installation clearances and requirements with the store before fitting multiple accessories. These are curated shopping suggestions, not a new combined SKU."
    ]
  },
  {
    "key": "tes-bundle-4",
    "model": "Model 3 Highland",
    "name": "Highland Tech Essentials",
    "description": "Charging, cabin lighting and practical front-to-back upgrades.",
    "fit": "Model 3 Highland · 2023.08+ · Left-hand drive",
    "items": [
      {
        "name": "Center Console USB Hub",
        "handle": "center-console-usb-hub-for-tesla-model-y-juniper-2025-model-3-highland-2023",
        "variant": "52297746678049",
        "spec": "Model 3 Highland（2023.08+）",
        "priceCents": 6200,
        "image": window.TES_HW.assets["assets/bundles/bundle-4-0.png"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_Center_Console_USB_Hub_for_Tesla_Model_Y_Juniper_2025_Model_3_Highland_2023.png?v=1770357428"
      },
      {
        "name": "BSD Ambient Light System",
        "handle": "tesla-bsd-blind-spot-ambient-light",
        "variant": "51411743605025",
        "spec": "Model 3 Highland (2023.8+）",
        "priceCents": 6900,
        "image": window.TES_HW.assets["assets/bundles/bundle-4-1.jpg"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/img_v3_02og_16667a9f-45d6-4c3a-9622-070e1e6e1e0g.jpg?v=1773734289"
      },
      {
        "name": "V2 Screen Swivel Mount",
        "handle": "tesla-screen-swivel-mount-model-3-y-highland-juniper",
        "variant": "50793369436449",
        "spec": "Model 3 Highland (2023.08+) / Upgraded V2 Version / Left Hand Drive",
        "priceCents": 8400,
        "image": window.TES_HW.assets["assets/bundles/bundle-4-2.jpg"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Swivel_Mount_Kit_Center_Screen_Rotating_Holder_New_Upgraded_V2_V3_Version_For_Tesla_Model_3_Y_3_Highland_Model_Y_Juniper.jpg?v=1760346783"
      },
      {
        "name": "3-in-1 Rear Screen Cup Holder",
        "handle": "rear-screen-cup-holder-3-in-1-for-tesla-model-3-highland-model-y-juniper",
        "variant": "51463296549153",
        "spec": "Model 3 Highland(23.8+）",
        "priceCents": 7100,
        "image": window.TES_HW.assets["assets/bundles/bundle-4-3.png"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_Rear_Screen_Cup_Holder_3_in_1_for_Model_3_Highland_Model_Y_Juniper.png?v=1762754193"
      }
    ],
    "notes": [
      "One of each selected item or retail set. Confirm the listed build date and options for every product.",
      "Left-hand-drive Highland only; the selected swivel bracket is the V2 version.",
      "Check installation clearances and requirements with the store before fitting multiple accessories. These are curated shopping suggestions, not a new combined SKU."
    ]
  },
  {
    "key": "tes-bundle-5",
    "model": "Cybertruck",
    "name": "Cybertruck Utility Upgrade",
    "description": "Everyday access, cabin refinements and a more organized truck bed.",
    "fit": "Cybertruck Premium AWD · 2024+",
    "items": [
      {
        "name": "Running Boards & Side Steps",
        "handle": "running-boards-side-steps-for-tesla-cybertruck-nerf-bars",
        "variant": "53000491598113",
        "spec": "Cybertruck Premium AWD",
        "priceCents": 49900,
        "image": window.TES_HW.assets["assets/bundles/bundle-5-0.jpg"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Running_Boards_Side_Steps_Exterior_Brackets_Nerf_Bars_For_Tesla_Cybertruck_Premium_AWD_2024.jpg?v=1786600236"
      },
      {
        "name": "V3 Screen Swivel Mount",
        "handle": "cybertruck-screen-swivel-tilt-mount-rotating-holder",
        "variant": "51953731600673",
        "spec": "Cybertruck Premium AWD 2024+ / Swivel Bracket Mount Kit V3(More Easy Install)",
        "priceCents": 15800,
        "image": window.TES_HW.assets["assets/bundles/bundle-5-1.png"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_Center_Screen_Swivel_Rotating_Mount_Kit_For_Cybertruck_Swivel_Bracket_Mount_Kit_V3_More_Easy_Install.png?v=1772675332"
      },
      {
        "name": "Car Door Seal Kit",
        "handle": "cybertruck-car-door-seal-kit-noise-reduction",
        "variant": "52901758435617",
        "spec": "Cybertruck Premium AWD 2024+",
        "priceCents": 6600,
        "image": window.TES_HW.assets["assets/bundles/bundle-5-2.jpg"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_Car_Door_Seal_Kit_Soundproof_Wind_Noise_Reduction_For_Cybertruck.jpg?v=1759990659"
      },
      {
        "name": "Vertical Cargo Divider",
        "handle": "tesstudio-tesla-accessories-cargo-divider-for-tesla-cybertruck",
        "variant": "50262767829281",
        "spec": "Cybertruck Premium AWD 2024+ / Vertical Style / Cargo Divider",
        "priceCents": 37900,
        "image": window.TES_HW.assets["assets/bundles/bundle-5-3.jpg"],
        "sourceImage": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Vault_Cargo_Divider_Rear_Trunk_Bed_Divider_For_Tesla_Cybertruck.jpg?v=1779863196"
      }
    ],
    "notes": [
      "One of each selected item or retail set. Confirm the listed build date and options for every product.",
      "Cybertruck Premium AWD 2024+ only. The cargo divider is the vertical style, without a bag add-on.",
      "Check installation clearances and requirements with the store before fitting multiple accessories. These are curated shopping suggestions, not a new combined SKU."
    ]
  }
];

